<template>
  <div class="wrapper-page loginBgImage">
    <div class="row d-none d-md-flex login-header d-flex justify-content-center">
      <div class="col col-md-6 ">
        <div class="logo pl-md-3 px-2 pt-5 d-flex justify-content-center">
          <img class="text-center" src="/assets/images/logo-text_2.png" />
        </div>
      </div>
    </div>
    <div class="card login-card">
      <div class="card-body">
        <h3 class="text-center mt-3 mb-4">帳號登入</h3>
        <!-- 重要通知 -->
        <!-- 無權限警告 -->
        <!-- <div class="col-12">
          <div class="alert alert-danger fade show" role="alert">
          <i class="mdi mdi-block-helper mr-2"></i>
          您目前沒有該系統權限，請聯絡管理者以取得權限。
          </div>
        </div> -->

        <form class="form-horizontal">
          <div class="col-12">
            <div class="form-group">
              <div class="input-group">
                <div class="input-group-addon">
                  <i class="fas fa-user"></i>
                </div>
                <input v-model="id" id="email" type="text" class="form-control" placeholder="Account" required>
              </div>
            </div>
          </div>

          <div class="col-12">
            <div class="form-group">
              <div class="input-group">
                <div class="input-group-addon">
                  <i class="fas fa-lock"></i>
                </div>
                <input v-model="pwd" id="password" type="password" class="form-control" placeholder="Password" required>
              </div>
            </div>
          </div>

          <div class="form-group">
            <div class="col-12">
              <div class="checkbox checkbox-info">
                <input id="checkbox-signup" type="checkbox" v-model="remember_me" checked>
                <label for="checkbox-signup" class="text-muted">
                  Remember me
                </label>
              </div>
            </div>
          </div>

          <div class="form-group text-center mt-5">
            <div class="col-12">
              <div @click="login" class="btn btn-info btn-block btn-lg waves-effect waves-light">登入</div>
            </div>
          </div>

          <div class="form-group row m-t-30 m-b-0">
            <div class="col-sm-12 text-center">
              <a href="./forget" class="text-muted"> 忘記密碼 <i class="fa fa-question"></i></a>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { api } from "../../../apis/main.js"
let $ = window.$;
export default {
  name: 'LoginView',
  props: {
  },
  components: {
  },
  data() {
    return {
      id: "",
      pwd: "",
      remember_me: localStorage.rememberMe ?? false,
    }
  },
  watch: {
    remember_me(val) {
      if (val) {
        localStorage.rememberMe = true;
      } else {
        localStorage.rememberMe = null;
        localStorage.rememberAccount = '';
      }
    },
  }
  , mounted() {
    if (localStorage.rememberMe && localStorage.rememberAccount) {
      this.id = localStorage.rememberAccount;
    }

    let self = this;
    $('body').on('keydown', function (e) {
      if (e.keyCode == 13) {
        self.login();
      }
    });
  },
  updated() {

  },
  methods: {
    login() {
      api.post('/login', {
        "account": this.id,
        "password": this.pwd,
      }).then(res => {
        if (res.data.code != 1000) {
          localStorage.rememberAccount = '';
          localStorage.jwt = ''
          localStorage.page_permission = ''
          localStorage.system_permission = ''
          localStorage.area = ''
          // 超過90天未改密碼強制跳轉改密碼
          if (res.data.code === 9004) {
            swal({
              title: "請修改密碼",
              type: "warning",
              text: res.data.error_return
            }, () => {
              window.location.href = res.data.data.link;
            });
          } else {
            toastr.error(res.data.error_return);
          }
          return;
        }
        localStorage.rememberAccount = this.id;
        localStorage.jwt = res.data.data.token
        localStorage.page_permission = res.data.data.pages_permission.split('-')[1]
        localStorage.system_permission = res.data.data.pages_permission.split('-')[0]
        localStorage.area = res.data.data.area
        this.$router.push('/')
      }).catch(rea => {
        console.error(rea);
      })
    }
  }
}
</script>

<style scoped></style>
